var DialogEquipmentsModule = /** @class */ (function () {
    function DialogEquipmentsModule() {
    }
    return DialogEquipmentsModule;
}());
export { DialogEquipmentsModule };
